// Signed-in user for the whole app. Provided by <SessionProvider> in App.tsx.
import { createContext, useContext } from "react";
import type { Me } from "./api/types";

export interface SessionValue { me: Me; signOut: () => void }
export const SessionContext = createContext<SessionValue | null>(null);

export function useSession(): SessionValue {
  const s = useContext(SessionContext);
  if (!s) throw new Error("useSession must be used inside SessionContext");
  return s;
}
